
$( document ).ready(function() {
  if($('h1').length == 0){
    let elm = $('.logo_wrapper a').detach();
    let h1 = $('.logo_wrapper').append('<h1 id="site-title-logo" />')
    elm.appendTo("#site-title-logo")
    
  }
    
  window.rechargeCustomTheme = { 
    selectors: {
        variant: ['.single-option-selector'],
        injectionParent: '.autopilot-wrapper',
        price: ['.price-item']
    }
  }

  setTimeout(function(){
  var shadowroot = document.querySelector(".product-form shopify-payment-terms").shadowRoot
  if(typeof shadowroot != "undefined"){
    shadowroot.querySelector('svg').innerHTML = '<title>Shop Pay</title>' + shadowroot.querySelector('svg').innerHTML;
  
    }
    },500)
  
  $('body').on('DOMSubtreeModified', '.site-header__cart-count span', function(){
    $('.main_header_headers_mobile .mobile_cart_bar span:first-child').html($(this).html());
  });
  $('.single_filter_option h4').on('click',function(){
    $(this).parent().toggleClass('open');
  });
  $('body').on('DOMSubtreeModified', '.site-nav', function(){
    var currentPage = location.href.replace(/^.*\/\/[^\/]+/, '');
    var allA = document.querySelectorAll('.tmenu_submenu a');
    for(var i = 0, len = allA.length; i < len; i++) {
        if(allA[i].href.replace(/^.*\/\/[^\/]+/, '') == currentPage) {

             allA[i].classList.add("active");
           allA[i].closest(".tmenu_item_level_0").classList.add("active");
        }
    }
  });
  // $('.single_addOto_button').on('click', function(e){e.preventDefault();})
  $('.top_menu a:not(.site-header__cart),.main_menu_wrapper ul li a, .single_footer_navigation a').each(function(elm) {
            var timer_1;
            var timer_2;
            var _this = this;
            $(this).on('mouseenter', function() {
                clearTimeout(timer_1);
                clearTimeout(timer_2);
                timer_1 = setTimeout(function() {
                    $(_this).addClass('out-right');
                }, 300);
            }).on('mouseleave', function() {
                clearTimeout(timer_1);
                clearTimeout(timer_2);
                timer_2 = setTimeout(function() {
                    $(_this).addClass('reset');
                    setTimeout(function() {
                        $(_this).removeClass('reset');
                        $(_this).removeClass('out-right');
                    }, 50);
                }, 300);
            });
        });
  ;(function() {
    var throttle = function(type, name, obj) {
        var obj = obj || window;
        var running = false;
        var func = function() {
            if (running) { return; }
            running = true;
            requestAnimationFrame(function() {
                obj.dispatchEvent(new CustomEvent(name));
                running = false;
            });
        };
        obj.addEventListener(type, func);
    };
    throttle ("scroll", "optimizedScroll");
})();
var oval = document.querySelector(".big-oval img");
  var bg_bar = document.querySelector(".bg-bar");
		
    window.addEventListener("optimizedScroll", function() {
        if(oval != null){
    	oval.style.transform = 'rotate('+((window.pageYOffset/100)* -1) +'deg)';
            }
      if(bg_bar != null){
    	bg_bar.style.transform = 'translateY('+((window.pageYOffset/5)* -1) +'px) rotate(-'+(40-(window.pageYOffset/400))+'deg)';

  	}
	});

  
  /*
$(window).scroll(function() {
if ($(this).scrollTop() > 0){  
    $('.main_header_wrapper').addClass("sticky");
  }
  else{
    $('.main_header_wrapper').removeClass("sticky");
  }
});  
  
 */
  
   $(document).ready(function(){
     $("header.site-header.border-bottom.logo--left").sticky({topSpacing:0});
     $(".filter_overlay_wrappar").attr('style','');
  }); 
  
 $( ".single_product_bottom" ).click(function() {
  
  var parentquick = $(this).parents(".single_product_inner").find(".qimify-shopify-btn");
  console.log(parentquick);
  
  $( parentquick ).trigger( "click" );
 
});   
var dialogOpen = false
 $( ".collection_filter_button_area button" ).click(function() {
  
   dialogOpen = !dialogOpen;
   $(".filter_overlay_wrappar").toggleClass("overlay_show");
   $("body").toggleClass("overlay_shown");
   $("#filter-overlay-close").focus();

});   
  
  
  $( ".overlay_close" ).click(function() {
  dialogOpen = false;
 
   $(".filter_overlay_wrappar").toggleClass("overlay_show");
   $("body").toggleClass("overlay_shown");

});  
  
document.addEventListener("focus", function(event) {

    var d = document.getElementById("filter-overlay");

    if (dialogOpen && !d.contains(event.target)) {
        event.stopPropagation();
        d.focus();
    }

}, true);


document.addEventListener("keydown", function(event) {
    if (dialogOpen && event.keyCode == 27) {
        $( ".overlay_close" ).click()
    }
}, true);
  
 
 $('.owl-carousel.single_location_slider').owlCarousel({
    loop: true,
    margin:0,
    responsiveClass:true,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
   autoplay: true,
   autoplayTimeout: 4000,
   
    responsive:{
        0:{
            items:1,
            nav:true
        },
        600:{
            items:1,
            nav:false
        },
        1000:{
            items:1,
            nav:true,
            loop:true
        }
    }
}); 
  
  
  
});

